// 获取store中的 token
import axios from 'axios';
import { api } from './env.config';
import uuid from '@common/utils/uuid';
import { track } from '@common/utils/ServiceTrack';

export const server = api;

export const ajax = axios.create();

// axios 华住活动后台request拦截器 处理与华住活动后台相匹配的登录权限、数据格式等

ajax.interceptors.request.use((config) => {
  let { url, data, headers, method, params = {} } = config;
  // 处理url
  let baseURL = '';
  if (/^\//.test(url)) baseURL = api;
  // 处理数据格式
  if (!headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';

    if (method === 'post') {
      // let temp = [];
      // for (let i in data) {
      //     temp.push(i + '=' + encodeURI(data[i]));
      // }
      // data = temp.join('&');
    } else {
      params = params ? { ...data, ...params } : data;
    }
  }

  const requestId = uuid();

  return {
    ...config,
    // withCredentials: true,
    data,
    params,
    headers,
    baseURL,
    apiPath: url,
    timeout: 10000,
    requestStartTime: Date.now(),
    requestId,
  };
});

// axios 华住活动后台response拦截器 处理响应数据及底层容错

ajax.interceptors.response.use(
  (res) => {
    const {
      status,
      data,
      config: { requestStartTime, apiPath, requestId, uselog },
    } = res;
    const { message } = data;

    let tkcode = 1;

    if (data && data.businessCode != '1000') {
      tkcode = 0;
    }

    track.onEvent('service_portal_old_log', {
      portal_tag: 'api',
      portal_req_id: requestId,
      portal_type: apiPath || '',
      portal_apitimming: Date.now() - requestStartTime,
      portal_status: tkcode,
      portal_message: message,
    });

    if (status === 200) return data;
  },
  (error) => {
    const {
      config: { requestStartTime, apiPath, requestId },
      message,
    } = error;

    track.onEvent('service_portal_old_log', {
      portal_tag: 'api',
      portal_req_id: requestId,
      portal_type: apiPath || '',
      portal_apitimming: Date.now() - requestStartTime,
      portal_status: 0,
      portal_message: message,
    });

    return {
      code: 700,
    };
  }
);

/* ***** 接口列表 ***** */

/**
 * 获取用户信息
 * @returns {AxiosPromise}
 */
// export const getUserInfo = (data) =>
// 	ajax({
// 		url: "/campaign/member/info",
// 		data
// 	});

export const getEmployeeDataByHotelId = ({ hotelId }) =>
  ajax({
    url: `/temp/initInfo?hotelId=${hotelId}`,
    method: 'get',
  });

// 解析网关信息,获取认证基本参数 原始get请求
// export const getHotelInfo = data =>
//     ajax({
//         url: `/api/wifi/getHotelInfo`,
//         method: 'get',
//         data,
//     });

// 解析网关信息,获取认证基本参数 更改为post请求
export const getHotelInfo = (data) =>
  ajax({
    url: `/api/wifi/getHotelInfo`,
    method: 'post',
    data,
  });

// 判断是否华住会员
export const checkMember = (data) =>
  ajax({
    url: `/api/wifi/checkMember`,
    method: 'get',
    data,
  });

// 动态验证码登录
export const dynamicLogin = (data) =>
  ajax({
    url: `/api/wifi/dynamicLogin`,
    method: 'post',
    data,
  });

//	住客认证
export const tenantLogin = (data) =>
  ajax({
    url: `/api/wifi/tenantLogin`,
    method: 'post',
    data,
  });

// 获取国家码
export const countryCode = (data) =>
  ajax({
    url: `/api/common/countryCode`,
    method: 'get',
    data,
  });

// 获取短信验证码
export const sendMessage = (data) =>
  ajax({
    url: `/api/common/sendMessage/new`,
    method: 'post',
    data,
  });

// 获取用户返回展示信息
export const saveRecord = (data) =>
  ajax({
    url: `/wifiSuccess/saveRecord`,
    method: 'get',
    data,
  });
// 保存上网记录
export const customLogic = (data) =>
  ajax({
    url: `/wifiSuccess/customLogic`,
    method: 'get',
    data,
  });

//
export const awifiLogin = (data, url) =>
  ajax({
    url: url,
    method: 'get',
    data,
  });

export const getBanner = (data) =>
  ajax({
    url: `/api/handle/bannerConfig`,
    method: 'get',
    data,
  });

//获取全触点活动列表
export const getAllContact = (data) => {
  return ajax({
    url: `/api/fulltouch/getcfg`,
    method: 'post',
    data,
  });
};

//曝光活动
export const exposureActivity = (data) => {
  return ajax({
    url: '/api/fulltouch/addexposuretimes',
    method: 'post',
    data,
  });
};

// 查看是否是华住会员、是否是融创会员
export const checkHzAndRc = (data) =>
  ajax({
    url: `/api/wifi/checkHzAndRc`,
    method: 'get',
    data,
  });

//注册成为融创会员
export const beRcMember = (data) =>
  ajax({
    url: `/api/wifi/registRcMember`,
    method: 'post',
    data,
  });

//生成微信跳转链接
export const generateWxUrl = (data) =>
  new Promise((res, rej) => {
    ajax
      .post('/api/wifi/wxmpUrl', data)
      .then((data) => {
        if (data.status == 200 && data.data && data.data.url) {
          res(data.data);
        } else {
          rej(0);
        }
      })
      .catch((e) => {
        rej(e);
      });
  });

//上报设备
export const blacklist = (data) =>
  new Promise((res, rej) => {
    ajax
      .post('/api/wifi/blacklist', data)
      .then((data) => {
        res(data);
      })
      .catch((e) => {
        rej(e);
      });
  });

//轮询外网资源
export const fetchInternetSource = () =>
  new Promise((res, rej) => {
    var url = 'https://lf26-cdn-tos.bytecdntp.com/cdn/expire-1-M/min.js/0.2.3/$.min.js';

    axios
      .get(url, {
        timeout: 1000,
      })
      .then((response) => {
        res(1);
      })
      .catch((error) => {
        rej(0);
      });
  });

export const getPortalConfig = () =>
  new Promise((res, rej) => {
    axios
      .get('https://res-pub.huazhu.com/cossixhs/portal/PortalFrontendConfig.json', {
        timeout: 1000,
      })
      .then((response) => {
        res(response.data);
      })
      .catch((error) => {
        res(0);
        console.log('getPortalConfig', error);
      });
  });
